import { useReduxState } from 'hooks';
import { Icon } from 'components/common/icons';

interface Props {
  numberOfStars?: number;
  style?: React.CSSProperties;
  value: number;
}

const ReviewStars = ({ numberOfStars = 5, style, value }: Props) => {
  const { messages } = useReduxState();

  const ratings = Array.from(
    { length: numberOfStars },
    (_, index) => index + 1
  );

  return (
    <div
      aria-label={`${value} / ${numberOfStars} ${messages.tasksStars}`}
      className="stars"
      style={style}
    >
      {ratings.map((rating) =>
        value >= rating ? (
          <Icon className="filled" icon="star" fixedWidth={true} key={rating} />
        ) : value > rating - 1 ? (
          <Icon
            className="half"
            icon="star-half-alt"
            fixedWidth={true}
            key={rating}
          />
        ) : (
          <Icon
            className="empty"
            icon={['far', 'star']}
            fixedWidth={true}
            key={rating}
          />
        )
      )}

      <style jsx>{`
        .stars {
          display: inline-block;
        }
      `}</style>
    </div>
  );
};

export default ReviewStars;
